<div class="grid">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoListar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoListar">
			<div class="formgroup" *ngIf="permissaoInserir">
				<div class="p-fluid p-formgrid grid">
					<div class="field col-12 md:col-2">
						<button pButton pRipple routerLink="/apps/item-produto/inserir" label="Novo" icon="pi pi-plus"
							class="p-button-outlined sm:w-9rem"></button>
					</div>
				</div>
			</div>
			<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
				<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
			</div>
			<p-table #dt1 [value]="itensProdutos" dataKey="id" 
				[rows]="itensPaginados ? itensPaginados.size : 0"
				[loading]="loadingTable"
				[rowHover]="true" [paginator]="true"
				(onPage)="onPageChange($event)" 
				[totalRecords]="itensPaginados ? itensPaginados.totalElements : 0"
				[lazy]="true" [showCurrentPageReport]="true"
				 responsiveLayout="stack" styleClass=" p-datatable-sm"
				currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros">
				<ng-template pTemplate="caption">
					<div class="flex justify-content-between flex-column sm:flex-row">
						<div class="p-fluid sm:mr-2">
							<p-dropdown [options]="situacoesStatus" optionLabel="label" optionValue="value"
								emptyFilterMessage="Nenhum registro" name="situacao" ngModel #situacao="ngModel"
								[(ngModel)]="statusSelecionado" (onChange)="carregarItensProdutos(numeroPagina)">
							</p-dropdown>
						</div>
						<div class="p-fluid mt-2 sm:mt-0">
							<div class="flex">
								<span class="p-input-icon-left">
									<i class="pi pi-search"></i>
									<input pInputText type="text" #filter (input)="buscar($event)" placeholder="Buscar"
										class="w-full" />
								</span>
								<span class="ml-2">
									<button pButton class="p-button-outlined" icon="pi pi-filter-slash"
										pTooltip="Limpar Filtros" (click)="limpar()"></button>
								</span>
							</div>
						</div>
					</div>
				</ng-template>
				<ng-template pTemplate="header">
					<tr>
						<th pSortableColumn="descricao">
							Descrição
							<p-sortIcon field="descricao">
							</p-sortIcon>
						</th>
						<th pSortableColumn="codigo">
							Código
							<p-sortIcon field="codigo">
							</p-sortIcon>
						</th>
						<th pSortableColumn="grupo">
							Grupo
							<p-sortIcon field="grupo">
							</p-sortIcon>
						</th>
						<th pSortableColumn="grupo">
							Estoque Atual
							<p-sortIcon field="grupo">
							</p-sortIcon>
						</th>
						<th pSortableColumn="ativo">
							Status
							<p-sortIcon field="ativo">
							</p-sortIcon>
						</th>
						<th style="text-align: center;">
							<div *ngIf=" verificarPermissao('PERM_DETALHAR_PRODUTO') ||
							verificarPermissao('PERM_EDITAR_PRODUTO') ||
							verificarPermissao('PERM_EXCLUIR_PRODUTO')">
								Ações
							</div>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-item>
					<tr>
						<td>
							{{item.descricao}}
						</td>
						<td>
							{{item.codigo}}
						</td>
						<td>
							{{ item.subgrupo.grupo.descricao}} - {{ item.subgrupo.descricao}}
						</td>
						<td>
							{{ item.estoqueAtual }} {{ item.descricaoUnidadeMedida }}
						</td>
						<td>
							<span class="product-badge status-instock" *ngIf="item.ativo">ATIVO</span>
							<span class="product-badge status-outofstock" *ngIf="!item.ativo">INATIVO</span>
						</td>

						<td style="text-align: center;">
							<div>
								<button *ngIf="verificarPermissao('PERM_DETALHAR_PRODUTO')" pButton pRipple
									pTooltip="Detalhar"
									(click)="redirecionarPagina('/apps/item-produto/detalhar/' + item.id)" icon="pi pi-eye"
									class="p-button-info mr-2 mb-2"></button>
								<button *ngIf="verificarPermissao('PERM_EDITAR_PRODUTO')" pButton pRipple pTooltip="Editar"
									(click)="redirecionarPagina('/apps/item-produto/editar/' + item.id)"
									icon="pi pi-pencil" class="p-button-success mr-2 mb-2"></button>
								<button *ngIf="verificarPermissao('PERM_EXCLUIR_PRODUTO')" pButton pRipple
									pTooltip="Excluir" icon="pi pi-trash" (click)="excluirItemProduto(item.id)"
									class="p-button-danger mr-2 mb-2 sm"></button>
							</div>
						</td>

					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">Nenhum registro encontrado.</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="loadingbody">
					<tr>
						<td colspan="7">Carregando Produtos. Por favor aguarde.</td>
					</tr>
				</ng-template>
			</p-table>
			<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
		</div>
	</div>
</div>